<template>
  <div class="registration-window" id="restore-window">
    <div class="registration-window-fl">
      <div class="registration-window-wrap">
        <router-link :to="{ name: 'home' }" class="registration-window-close"></router-link>

        <div class="registration-window-title">Восстановление пароля</div>
        <div class="registration-window-log">
          <div class="tt-tabs tabs-rwr">
            <div class="index-tabs">
              <span @click="this.tabActive = 0" :class="this.tabActive === 0 ? 'active-ttab' : ''"
                >· Через телефон ·</span
              >
              <span @click="this.tabActive = 1" :class="this.tabActive === 1 ? 'active-ttab' : ''"
                >· Через почту ·</span
              >
            </div>
            <div class="index-panel">
              <div v-if="this.tabActive === 0" class="tt-panel">
                <div class="rwr-line">
                  <!--  <input
                    type="text"
                    name=""
                    v-model="phone"
                    class="rwr-input"
                    placeholder="Введите Ваш номер телефона"
                 /> -->
                  <phone :setValue="data => (this.phone = data)" :value="this.phone" />
                </div>
                <div style="clear: both; height: 10px"></div>
                <a @click="this.onSubmit" class="registration-btn">{{
                  this.isLoading ? 'Подождите' : 'Восстановить'
                }}</a>
                <div class="reg-label rwr-reg-label" style="opacity: 0.5; text-align: center">
                  ❗ На Ваш номер телефона придет пароль для входа. Логином является Ваш номер телефона.
                </div>
              </div>
              <div v-if="this.tabActive === 1" class="tt-panel">
                <div class="rwr-line">
                  <input type="text" name="" v-model="email" class="rwr-input" placeholder="Введите Вашу почту" />
                </div>
                <div style="clear: both; height: 10px"></div>
                <a @click="this.onSubmit" class="registration-btn">{{
                  this.isLoading ? 'Подождите' : 'Восстановить'
                }}</a>
                <div class="reg-label rwr-reg-label" style="opacity: 0.5; text-align: center">
                  ❗ На Вашу почту придет письмо с логином и паролем для входа. Если письмо не пришло, проверьте папку
                  спам.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OPEN_GLOBAL_POPUP, PASSWORD_FORGOT } from '@/store/actions.type'
import { toast } from 'vue3-toastify'
import { useI18n } from 'vue-i18n'
import Phone from '@/components/Fields/Phone'

export default {
  name: 'Restore',
  components: { Phone },
  data() {
    return {
      tabActive: 0,
      email: '',
      phone: '',
      regmethod: 'phone',
      isLoading: false,
    }
  },
  setup() {
    const { t, locale } = useI18n()
    return { t, locale }
  },
  methods: {
    onSubmit() {
      if (!this.isLoading) {
        this.isLoading = true

        this.$store
          .dispatch(
            PASSWORD_FORGOT,
            this.tabActive === 0
              ? {
                  phone: this.phone,
                }
              : {
                  email: this.email,
                }
          )
          .then(res => {
            this.isLoading = false
            toast.success('Успешно')
          })
          .catch(res => {
            this.isLoading = false
            toast.error(res?.data?.err)
          })
      }
    },
  },
  mounted() {
    this.$store.dispatch(OPEN_GLOBAL_POPUP, true)
  },
  unmounted() {
    this.$store.dispatch(OPEN_GLOBAL_POPUP, false)
  },
}
</script>
